module.exports = __webpack_public_path__ + "static/media/document-list-check.241670ee.svg";